
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatDistanceToNow } from 'date-fns';

interface RecentUserLogin {
  user_id: string;
  email: string;
  last_login: string | null;
  total_logins: number;
}

interface RecentUserActivityProps {
  recentLogins: RecentUserLogin[];
}

export const RecentUserActivity: React.FC<RecentUserActivityProps> = ({
  recentLogins,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent User Activity</CardTitle>
        <CardDescription>
          Latest user logins and activity across the platform
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {recentLogins.slice(0, 10).map((user) => (
            <div key={user.user_id} className="flex items-center justify-between">
              <div className="flex-1">
                <p className="font-medium text-sm">{user.email}</p>
                <p className="text-xs text-muted-foreground">
                  {user.last_login
                    ? `Last seen ${formatDistanceToNow(new Date(user.last_login), { addSuffix: true })}`
                    : 'Never logged in'
                  }
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="text-xs">
                  {user.total_logins} logins
                </Badge>
                <Badge 
                  variant={user.last_login && 
                    new Date(user.last_login) > new Date(Date.now() - 24 * 60 * 60 * 1000) 
                    ? 'default' : 'secondary'
                  }
                  className="text-xs"
                >
                  {user.last_login && 
                    new Date(user.last_login) > new Date(Date.now() - 24 * 60 * 60 * 1000) 
                    ? 'Active' : 'Inactive'
                  }
                </Badge>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
